import React, {useEffect, useState } from "react";
import { getAllContacts, addContact, getAllCustomers } from "../../utils/helper";
import Loader from "../../utils/Loader";
// import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { Link } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    name: null,
    email: null,
    phone: null,
    designation: null,
    customer: null,
};

export default function Contacts() {
    const [loading, setLoading] = useState(false);
    const [contacts, setContacts] = useState(null);
    const [customers, setCustomers] = useState(null);
    // const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        setLoading(true);
        getAllContacts()
            .then((res) => { 
                setContacts(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getAllCustomers()
            .then((res) => {
                if(res.data.success){
                    setCustomers(res.data.data);  
                } 
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.name && data.email && data.phone && data.designation && data.customer){
            setLoading(true);
            addContact(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };


    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title"><Link to="/sales" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Contacts</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && contacts && contacts) ? 
                                    <div className="table-responsive">
                                        {(contacts && contacts.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name</th><th>Email</th><th>Phone</th><th>Designation</th><th>View</th></tr></thead>
                                            <tbody>
                                                {contacts && contacts.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.name && row?.name}</td>
                                                        <td>{row?.email && row?.email}</td>
                                                        <td>{row?.phone && row?.phone}</td>
                                                        <td>{row?.designation && row?.designation}</td>
                                                        <td>
                                                            <button 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD CONTACT</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Customer <span>*</span></label>
                                    <select className="form-control form-select" name="customer" id="sector" required 
                                    onChange={handleChange} defaultValue={state.customer && state.customer} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {customers && customers.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="name" className="form-control" required placeholder="Name of Contact" 
                                     onChange={handleChange} defaultValue={state.name && state.name} disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Email <span>*</span></label>
                                    <input type="email" name="email" className="form-control" required placeholder="Email of Contact" 
                                     onChange={handleChange} defaultValue={state.email && state.email }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Phone <span>*</span></label>
                                    <input type="tel" name="phone" maxLength={11} className="form-control" required placeholder="Phone of Contact" 
                                     onChange={handleChange} defaultValue={state.phone && state.phone }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Designation <span>*</span></label>
                                    <input type="text" name="designation" className="form-control" required placeholder="Designation of Contact" 
                                     onChange={handleChange} defaultValue={state.designation && state.designation }  disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
